query GetContextDocumentUsage {
    contextDocumentUsage {
        wordsUsage
        wordsLimit
        webPagesUsage
        pdfsUsage
        pagesLimit
        limitExceededReason
    }
}
